import { useTranslation } from 'react-i18next'
import { InAppTemplateData } from '../../../../types'
import { Alert } from '../../../../ui'
import { hasDismissAction } from './dismissAction'

export const NoDismissAlert = ({ data }: { data: Pick<InAppTemplateData, 'html' | 'read_on_show'> }) => {
    const { t } = useTranslation()
    if (hasDismissAction(data.html)) return null
    const body = data.read_on_show
        ? t('inapp_no_dismiss_message')
        : `${t('inapp_no_dismiss_message')} ${t('inapp_no_dismiss_repeat')}`
    return <Alert variant="warn" size="small" title={t('inapp_no_dismiss_title')} body={body} />
}
